<div class="modal-header">
  <h4 class="h5-text modal-title w-100">
    Important Notice
  </h4>
  <ng-content select=".modal-header-container" />
  <button type="button" class="close" (click)="activeModal.dismiss('Cross click')" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
@if (notificationMsg !== '') {
  <div class="modal-body" ngbAutofocus>
    <div class="row">
      <div class="col-12 mb-2 mt-2" [innerHTML]="notificationMsg"></div>
    </div>
    <div class="row mb-2 mt-2">
      <div class="col-12">
        <button type="button" class="btn btn-primary mr-2" (click)="dismissNotice()" style="height:38px;line-height:38px" [disabled]="isImpersonated">Dismiss this Notice</button>
        <span class="material-icons-outlined ml-2" [ngbTooltip]="'Please note that you will still be able to access the notice in the notices section under the Bell icon. This will not impact future notices.'" style="vertical-align:middle">info</span>
      </div>
    </div>
  </div>
}
@if (notificationMsg === '' && notificationFlaggedMsg !== '') {
  <div class="modal-body" ngbAutofocus>
    <div class="row">
      <div class="col-12 mb-2 mt-2" [innerHTML]="notificationFlaggedMsg"></div>
    </div>
  </div>
}
@if (notificationFlaggedMsg !== '' && notificationMsg !== '') {
  <div class="modal-footer" style="display: block">
    <div class="row">
      <div class="mb-2 mt-2" [innerHTML]="notificationFlaggedMsg"></div>
    </div>
  </div>
}
